<template>
    <v-app-bar 
    app 
    color="#343A40" 
    dark 
    >
        <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->

        <a href="/">
            <v-img 
            src="/static/e4e_fmoh_iss_spa_forms_reporter_static/dist/imgs/logo_fmoh_default.png" 
            alt="fmoh-logo" 
            color="#343A40" 
            contain max-width="128px" max-height="128px" >
            </v-img>
        </a>

        <!--<v-appbar-title>FMOH-ISS</v-appbar-title>-->

        <!--<v-spacer></v-spacer>-->

        <v-btn 
        text 
        :href="url_link_fmoh_iss()">
            Profile
        </v-btn>

        <v-divider inset vertical></v-divider>

        <!-- ===================================================== -->
        <!-- SLOT FOR THE MODULE HEADER COMPONENT nav links -->
        <!-- ===================================================== -->
        <slot name="slot_nav_links"></slot>
        <!-- ===================================================== -->

    </v-app-bar>
</template>

<script>
//########################################
//IMPORTS libs
//########################################
import {Facades_Apps_Urls} from '@/libs/links/links_to_pages.js';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentHeaderBarDefault',

    methods:{
        url_link_fmoh_iss:function()
        {
            return Facades_Apps_Urls.fmoh_iss_page_home(
                this.$route.params.username
            );
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
